// 소셜 로그인 버튼 — **서버가 켜 둔 공급자만** 그린다 (IMP-6a)
//
// ⚠️ 왜 컴포넌트로 묶었나: 버튼과 그 아래 구분선("또는 이메일로 …")은 **함께**
//    사라져야 한다. 따로 두면 공급자가 없을 때 아무것도 안 가르는 구분선만 남는다.
//    두 화면(로그인·가입)에 같은 배관을 두 벌 두면 한쪽만 고치는 사고가 난다(IMP-39).
import { useEffect, useState } from "react";
import { fetchSocialProviders, startSocialLogin, type SocialProvider } from "./authApi.ts";

/** 버튼에 쓰는 표기 — 각 사가 쓰는 이름을 그대로 따른다 */
const LABEL: Record<SocialProvider, string> = {
  kakao: "카카오",
  naver: "네이버",
  google: "Google",
};

/**
 * 버튼 왼쪽 브랜드 마크.
 *
 * 지금은 naver 만 쓴다. naver 는 **흰 배경 변형**으로 바꿨는데(초록 채움 위의
 * 흰 글자가 2.25:1 로 4.5:1 에 크게 미달했다) 그 변형은 가이드가 초록 로고를
 * 함께 요구하고, 마크가 없으면 같은 흰 배경인 Google 버튼과 구별되지 않는다.
 *
 * kakao 는 노란 채움 자체가 식별 단서라 마크 없이도 구별된다(어두운 글자 14.20:1).
 *
 * ⚠️ 로고를 SVG 로 **손으로 그려 넣지 않았다.** 부정확하게 옮긴 로고는 글자만
 *    있는 지금보다 브랜드 가이드 위반이 크다. naver 마크는 '초록 사각 + 흰 N'
 *    으로, 네이버 앱 아이콘과 같은 구성이면서 글자 N 을 그대로 쓰기 때문에
 *    형태가 틀어질 여지가 없다. 정식 브랜드 SVG 자산이 들어오면 이 표만
 *    갈아 끼우면 된다.
 */
const MARK: Partial<Record<SocialProvider, string>> = {
  naver: "N",
};

export function SocialButtons({ verb, divider }: { verb: string; divider: string }) {
  // null = 아직 못 읽음, [] = 쓸 수 있는 공급자 없음. 둘 다 아무것도 그리지 않는다.
  const [providers, setProviders] = useState<SocialProvider[] | null>(null);

  useEffect(() => {
    // 응답이 늦게 오는 사이 화면을 떠나면 setState 가 경고를 낸다
    let alive = true;
    void fetchSocialProviders().then((list) => {
      if (alive) setProviders(list);
    });
    return () => {
      alive = false;
    };
  }, []);

  // ⚠️ 읽는 동안 자리를 비워 둔다. 껍데기를 그려 두면 목록이 도착할 때 개수가
  //    달라져 어차피 흔들리고, 무엇보다 **없는 버튼을 잠깐 보여주게** 된다.
  if (!providers || providers.length === 0) return null;

  return (
    <>
      <div className="social">
        {providers.map((p) => (
          <button key={p} type="button" className={p} onClick={() => startSocialLogin(p)}>
            {/* aria-hidden — 마크는 라벨을 되풀이하는 장식이다. 읽어 주면
                "N 네이버로 로그인"이 되어 화면 낭독기 사용자에게 방해가 된다. */}
            {MARK[p] && <span className="social-mark" aria-hidden="true">{MARK[p]}</span>}
            {LABEL[p]}로 {verb}
          </button>
        ))}
      </div>
      <div className="divider">{divider}</div>
    </>
  );
}
